import { render } from "./MainLayout.vue?vue&type=template&id=56e14c81"
import script from "./MainLayout.vue?vue&type=script&lang=js"
export * from "./MainLayout.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\giord\\Documents\\Progetti VS\\sito-giordan\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__